import React from "react";
import styles from "./styles.module.scss";

const FormManagement: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.heading}>Form Management</div>
          <div className={styles.subHeading}>
            Manage and configure your forms across the platform.
          </div>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.emptyState}>
          <p className={styles.emptyText}>Coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default FormManagement;
